<div class="container">
  <mat-card>
    <form [formGroup]="undoClientRejectionForm" (ngSubmit)="submit()">
      <mat-card-content>
        <mat-form-field class="flex-fill" (click)="reopenedDatePicker.open()">
          <mat-label>{{ 'labels.inputs.Reopened On Date' | translate }}</mat-label>
          <input
            matInput
            [min]="minDate"
            [max]="maxDate"
            [matDatepicker]="reopenedDatePicker"
            required
            formControlName="reopenedDate"
          />
          <mat-datepicker-toggle matSuffix [for]="reopenedDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #reopenedDatePicker></mat-datepicker>
          @if (undoClientRejectionForm.controls.reopenedDate.hasError('required')) {
            <mat-error>
              {{ 'labels.inputs.Reopened On Date' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          }
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!undoClientRejectionForm.valid">
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
